import React from 'react';
import { Tabs, Button } from 'antd';
import { ApiOutlined } from '@ant-design/icons';
import AuditLogTab from '../components/settings/AuditLogTab';
import AccessLogTab from '../components/settings/AccessLogTab';
import BackupTab from '../components/settings/BackupTab';
import AppSettingsTab from '../components/settings/AppSettingsTab';
import AiSettingsTab from '../components/settings/AiSettingsTab';
import GoogleDriveTab from '../components/settings/GoogleDriveTab';
import CommandRunsTab from '../components/settings/CommandRunsTab';

const { TabPane } = Tabs;

// Ayarlar artik sadece gercek sistem/admin konfigurasyonunu icerir - Bildirim
// Gonder/Sablonlari ve Onay Metinleri (eskiden KVKK) sube muduru de kullandigi
// icin kendi sidebar sayfalarina tasindi (bkz. Notifications.jsx, ConsentTexts.jsx).
// Kategoriler altinda gruplanmis iki seviyeli yapi - duz 8+ sekme yerine.
const openApiDocs = () => {
  const apiBase = (process.env.REACT_APP_API_URL || '/api').replace(/\/api\/?$/, '');
  window.open(`${apiBase}/api/documentation`, '_blank');
};

const Settings = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Ayarlar</h2>
      <Tabs defaultActiveKey="general" type="card">
        <TabPane tab="Genel" key="general">
          <Tabs defaultActiveKey="app-settings">
            <TabPane tab="Uygulama Ayarları" key="app-settings">
              <AppSettingsTab />
            </TabPane>
            <TabPane tab="Yapay Zeka" key="ai-settings">
              <AiSettingsTab />
            </TabPane>
          </Tabs>
        </TabPane>
        <TabPane tab="Yedekleme" key="backup">
          <Tabs defaultActiveKey="backups">
            <TabPane tab="Veritabanı Yedekleri" key="backups">
              <BackupTab />
            </TabPane>
            <TabPane tab="Google Drive Yedekleme" key="google-drive">
              <GoogleDriveTab />
            </TabPane>
          </Tabs>
        </TabPane>
        <TabPane tab="Loglar" key="logs">
          <Tabs defaultActiveKey="audit">
            <TabPane tab="Denetim Logları" key="audit">
              <AuditLogTab />
            </TabPane>
            <TabPane tab="Erişim Logları" key="access">
              <AccessLogTab />
            </TabPane>
          </Tabs>
        </TabPane>
        <TabPane tab="Sistem" key="system">
          <div className="mb-4">
            <Button icon={<ApiOutlined />} onClick={openApiDocs}>API Docs</Button>
          </div>
          <CommandRunsTab />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default Settings;
